const OTPlugin = require('../otplugin/otplugin.js');
const env = require('../helpers/env.js');

// Indicates whether this client supports the getUserMedia API.

module.exports = () => Boolean(
  env.name !== 'Node' &&
  (
    global.navigator.webkitGetUserMedia ||
    global.navigator.mozGetUserMedia ||
    (global.navigator.mediaDevices && global.navigator.mediaDevices.getUserMedia) ||
    OTPlugin.isInstalled()
  )
);



// WEBPACK FOOTER //
// ./src/js/helpers/hasGetUserMediaCapability.js